import * as actionTypes from "../ActionTypes";



// 🔹 SAVE TEAM COVER IMAGE
export const saveTeamCoverImageRequest = ({ apiPayloadRequest, callback }) => ({
  type: actionTypes.SAVE_TEAM_COVERIMAGE_REQUEST,
  payload: { apiPayloadRequest, callback },
});


export const saveTeamCoverImageSuccess = (data) => ({
  type: actionTypes.SAVE_TEAM_COVERIMAGE_SUCCESS,
  payload: data,
});

export const saveTeamCoverImageFailure = (error) => ({
  type: actionTypes.SAVE_TEAM_COVERIMAGE_FAILURE,
  payload: error,
});

// 🔹 UPDATE TEAM COVER IMAGE
export const updateTeamCoverImageRequest = ({ apiPayloadRequest, callback }) => ({
  type: actionTypes.UPDATE_TEAM_COVERIMAGE_REQUEST,
  payload: { apiPayloadRequest, callback },
});

export const updateTeamCoverImageSuccess = (data) => ({
  type: actionTypes.UPDATE_TEAM_COVERIMAGE_SUCCESS,
  payload: data,
});

export const updateTeamCoverImageFailure = (error) => ({
  type: actionTypes.UPDATE_TEAM_COVERIMAGE_FAILURE,
  payload: error,
});

export const deleteTeamCoverImageRequest = ({ apiPayloadRequest, callback }) => ({
  type: actionTypes.DELETE_TEAM_COVERIMAGE_REQUEST,
  payload: { apiPayloadRequest, callback },
});
export const deleteTeamCoverImageSuccess = (data) => ({
  type: actionTypes.DELETE_TEAM_COVERIMAGE_SUCCESS,
  payload: data,
});
export const deleteTeamCoverImageFailure = (error) => ({
  type: actionTypes.DELETE_TEAM_COVERIMAGE_FAILURE,
  payload: error,
});